export default __webpack_public_path__ + "static/media/tut-alert.24523e90.jpg";